// @flow
import axios from 'lib/defaultClient';

export const getTempSaveList = (brandId: string) => axios.get(`/brands/${brandId}/saves`);

export type LoadTempSavePayload = {
  brandId: string,
  saveId: string,
};

export const loadTempSave = ({ brandId, saveId }: LoadTempSavePayload) => {
  return axios.get(`/brands/${brandId}/saves/${saveId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/brands/saves.js